<template>
  <div v-if="variant === name">
    <template v-if="isMobile">
      <slot name="mobile" />
    </template>
    <template v-else>
      <slot name="desktop" />
    </template>
    <slot />
  </div>
</template>
<script>
import { defineComponent, inject } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  props: {
    name: {
      type: String,
      default: 'default',
    },
  },
  setup() {
    const variant = inject('articleVariant');
    const { isMobile } = useDevice();
    return { isMobile, variant };
  },
});
</script>
